import { Dialog } from '@mui/material'
import { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  CustomCheckBox,
  CustomInput,
  CustomSelect,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import { InfoWithHeadingDescriptionAndImage } from 'src/consumer/components/ListingPageComponentsAndHelpers/ListingPageComponents'
import { PublicAppFooter } from 'src/consumer/components/PublicAppFooter'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { SEOComponent, validateEmail } from 'src/consumer/helpers/utilFunctions'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'
import {
  MentorJoinModalContent,
  MentorOnboardingFormComponent,
  StyledDialogActions,
  StyledDialogJoinButton,
  StyledDialogPaper,
  StyledDialogSingleAction,
  StyledDialogTitle,
  StyledDialogVerifiedButton,
  StyledEmailNotVerifiedMessage,
  StyledMentorEmailInputAndMessageContainer,
  StyledMentorJoinVerifyLink,
  StyledMentorJoinVerifyLinkAfter,
} from 'src/mentor/components/MentorPublicPage/MentorPublicPageStyledComponents'
import { getImageLink, isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { getMPDataWithoutParams, postMPDataWithoutParams } from 'src/mentor/services'
import {
  ClinicPageBecomeClinicButton,
  ClinicPageInfo,
  ClinicPagePrimaryWidgetBackground,
  ClinicPagePrimaryWidgetItemsContainer,
  ClinicPageSubtitle,
  ClinicPageTitle,
  ClinicPublicPageContent,
  ClinicPublicPageLayout,
} from './ClinicPromotionPublicPageStyles'
import { StyledPhoneInputContainer } from 'src/clinic/views/onboardng/ClinicOnboardingStyles'
import { StyledMentorPhoneNumberInput } from 'src/mentor/components/MentorProfilePage/MentorProfilePageStyles'

export default function ClinicPromotionPublicPage({ blankPage }) {
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [showJoinForm, setShowJoinForm] = useState(blankPage ? true : false)
  const [formState, setFormState] = useState({})
  const [profileData, setProfileData] = useState()
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const availableRoles = getAllRolesInBoolean()
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  function handleChange(event) {
    if (event.target.type === 'checkbox') {
      setFormState((prev) => ({ ...prev, [event.target.id]: event.target.checked }))
    } else {
      setFormState((prev) => ({ ...prev, [event.target.id]: event.target.value }))
    }
  }

  function handleJoinClinic() {
    if (token && isBasicOnboardingDone(profileData)) {
      handleOpenForm()
    } else if (token && !isBasicOnboardingDone(profileData)) {
      handleOpenForm()
      // navigate('/onboarding', {
      //   state: {
      //     redirectAfterLogin: true,
      //     redirectAfterRegistration: true,
      //     redirectAfterOnboarding: false,
      //     redirectTo: '/aumhum-for-clinics/apply',
      //     redirectData: {
      //       mustHaveDoneBasicOnboarding: true,
      //       prospectiveClinic: true,
      //     },
      //   },
      // })
    } else {
      setShowClubbedAuthModal(true)
      // navigate('/onboarding', {
      //   state: {
      //     redirectAfterLogin: true,
      //     redirectAfterRegistration: true,
      //     redirectAfterOnboarding: false,
      //     redirectTo: '/aumhum-for-clinics/apply',
      //     redirectData: {
      //       mustHaveDoneBasicOnboarding: true,
      //       prospectiveClinic: true,
      //     },
      //   },
      // })
    }
  }

  function handleOpenForm() {
    if (
      availableRoles?.isClinicManager ||
      availableRoles?.isClinicProspect ||
      availableRoles?.isClinicOwner
    ) {
      navigate('/clinic-home')
    } else {
      setShowJoinForm(true)
    }
  }

  function handleClose() {
    if (blankPage) {
    } else {
      setShowJoinForm(false)
    }
  }

  async function getProfileData() {
    const resp = await getMPDataWithoutParams('/api/secure/user/profile')
    if (resp?.status === 200) {
      const profileData = resp.data
      setProfileData(profileData)
      const locationCountryCode = localStorage.getItem('countryCode') || 'in'
      const foundCountry = unSecureSetupData?.metaCountries.find(
        (country) => country.id === locationCountryCode.toLowerCase(),
      )
      // setEmailNotVerifiedShow && !resp?.data?.emailVerified && setEmailNotVerifiedShow(true)
      // setEmailNotVerifiedShow && resp?.data?.emailVerified && setEmailNotVerifiedShow(false)
      setFormState((prev) => {
        console.log(prev)
        console.log(resp?.data?.email)
        return {
          ...prev,
          email: prev?.email || resp?.data?.email || '',
          firstName: prev?.firstName || resp?.data?.firstName || '',
          location: {
            country:
              prev?.location?.country ||
              resp?.data?.location?.country ||
              foundCountry?.title ||
              foundCountry?.name ||
              '',
            countryCode:
              prev?.location?.countryCode ||
              resp?.data?.location?.countryCode ||
              foundCountry?.id ||
              '',
          },
        }
      })
    }
  }

  async function Setup() {
    await Promise.all([getProfileData()])
  }

  async function handleSubmit(event) {
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      event.preventDefault()
      const { terms, ...toSubmit } = formState
      const response = await postDataWithoutParams('/api/secure/cp/new', toSubmit)
      if (response.status === 200) {
        const role = localStorage.getItem('authorities')
        const role_array = JSON.parse(role)
        localStorage.setItem('onboardingClinicUser', true)
        localStorage.setItem('authorities', JSON.stringify([...role_array, 'ROLE_CLINIC_PROSPECT']))
        // above line is needed as in clinic layout normal profile is not yet called
        navigate('/clinic-home/new-brand-onboarding')
      }
    }
  }

  useEffect(() => {
    Setup()
  }, [])

  useEffect(() => {
    if (
      blankPage &&
      (availableRoles?.isClinicProspect ||
        availableRoles?.isClinicManager ||
        availableRoles?.isClinicOwner)
    ) {
      navigate('/clinic-home')
    }
  }, [])

  // public page and redirection:
  function goToLogin() {
    setTypeOfClubbedAuthModal('login')
    setShowClubbedAuthModal(true)
    // navigate('/login', {
    //   state: {
    //     redirectAfterLogin: true,
    //     redirectAfterRegistration: true,
    //     redirectAfterOnboarding: false,
    //     redirectTo: '/aumhum-for-clinics/apply',
    //     redirectData: {
    //       mustHaveDoneBasicOnboarding: true,
    //       prospectiveClinic: true,
    //     },
    //   },
    // })
  }
  function goToRegister() {
    setTypeOfClubbedAuthModal('signup')
    setShowClubbedAuthModal(true)
    // navigate('/onboarding', {
    //   state: {
    //     redirectAfterLogin: true,
    //     redirectAfterRegistration: true,
    //     redirectAfterOnboarding: false,
    //     redirectTo: '/aumhum-for-clinics/apply',
    //     redirectData: {
    //       mustHaveDoneBasicOnboarding: true,
    //       prospectiveClinic: true,
    //     },
    //   },
    // })
  }

  const clinicAssistantShortcutActive = availableRoles?.isClinicAssistant

  return (
    <>
      <PublicAppHeader loginFunction={goToLogin} registerFunction={goToRegister} />
      <SEOComponent
        title="Empower Your Patients with AUMHUM Clinic | AUMHUM"
        description="Join AUMHUM Clinic to empower your patients with innovative, personalized mental health care, enhancing your practice and leading in mental health excellence."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['clinic', 'patients', 'portal']}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => {
          setShowClubbedAuthModal(false)
        }}
        loginVariant={typeOfClubbedAuthModal === 'login'}
        nameFieldHeading={'Clinic Owner Name'}
      />

      {blankPage ? (
        <></>
      ) : (
        <ClinicPublicPageLayout>
          <ClinicPagePrimaryWidgetItemsContainer>
            <ClinicPublicPageContent>
              <ClinicPageSubtitle>For Clinics</ClinicPageSubtitle>
              <ClinicPageTitle>Ready to revolutionize</ClinicPageTitle>
              <ClinicPageTitle>your patients&apos; experience?</ClinicPageTitle>
              <ClinicPageInfo></ClinicPageInfo>
              {clinicAssistantShortcutActive && (
                <ClinicPageBecomeClinicButton
                  style={{ marginRight: '10px', marginBottom: '10px' }}
                  onClick={() => navigate('/ca-home')}
                >
                  Use AUMHUM as Clinic Assistant
                </ClinicPageBecomeClinicButton>
              )}
              <ClinicPageBecomeClinicButton onClick={handleJoinClinic}>
                {availableRoles.isClinicManager ||
                availableRoles.isClinicProspect ||
                availableRoles.isClinicOwner
                  ? 'Go to your Clinic Dashboard'
                  : 'Apply to become an AUMHUM Clinic'}
              </ClinicPageBecomeClinicButton>
            </ClinicPublicPageContent>
            <ClinicPagePrimaryWidgetBackground
              src={getImageLink(APP_CONSTANTS.CLINIC_PUBLIC_PAGE_MAIN_IMAGE)}
              alt="background"
            />
          </ClinicPagePrimaryWidgetItemsContainer>
          <InfoWithHeadingDescriptionAndImage
            headline="Elevate Your Booking Management"
            description="Our portal empowers your clinic's staff to effortlessly manage bookings for doctors. Doctors can easily schedule both online and offline sessions, and have full visibility into their appointments right from the portal."
            image={getImageLink(APP_CONSTANTS.CLINIC_PUBLIC_PAGE_SCHEDULE_IMAGE)}
          />
        </ClinicPublicPageLayout>
      )}

      <ClinicPublicPageBecomeClinicPopup
        open={showJoinForm}
        onClose={handleClose}
        formState={formState}
        profileData={profileData}
        handleChange={handleChange}
        setFormState={setFormState}
        onSubmit={handleSubmit}
        getProfileData={getProfileData}
      />
      <PublicAppFooter />
    </>
  )
}

export function ClinicPublicPageBecomeClinicPopup({
  onSubmit,
  handleChange,
  profileData,
  formState,
  setFormState,
  getProfileData,
  ...rest
}) {
  // const enableEmail = profileData?.email !== undefined && profileData?.email !== ''
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [clicked, setClicked] = useState(false)
  const [showEmailNotVerified, setShowEmailNotVerified] = useState(false)
  const [verifyingEmail, setVerifyingEmail] = useState(false)
  const emailValid = validateEmail(formState?.email)
  const disableJoinClinicButton = useMemo(() => {
    return true
    // if (profileData?.emailVerified) {
    //   return true
    // }
    // return false
  }, [clicked, profileData])

  async function verifyEmail() {
    setVerifyingEmail(true)
    await getProfileData()
    setVerifyingEmail(false)
  }

  function changeCountry(selectValue) {
    setFormState((prev) => ({
      ...prev,
      location: { ...prev?.location, countryCode: selectValue?.id, country: selectValue?.name },
    }))
  }

  useEffect(() => {
    if (profileData?.emailVerified) {
      setClicked(false)
      setShowEmailNotVerified(false)
    } else {
      setShowEmailNotVerified(true)
    }
  }, [profileData])

  function handleChangePhone(phone) {
    const phoneToSet = '+' + phone
    handleChange({ target: { id: 'waId', value: phoneToSet } })
  }

  useEffect(() => {
    console.log({ formState })
  }, [formState])

  return (
    <Dialog PaperComponent={StyledDialogPaper} {...rest}>
      <StyledDialogTitle>Get AUMHUM for your Clinic</StyledDialogTitle>
      <MentorJoinModalContent>
        <MentorOnboardingFormComponent id="join-mentor-form" onSubmit={onSubmit}>
          {/* <CustomInput
            id="firstName"
            type="text"
            label="Clinic Brand Name"
            value={formState?.firstName}
            onChange={handleChange}
            required
          /> */}
          {/* <div className="d-flex justify-content-stretch align-items-center">
            <CustomInput
              id="email"
              type="email"
              label="Email"
              invalid={!emailValid}
              invalidMessage={formState?.email && 'Your email address is in the wrong format.'}
              valid={profileData?.emailVerified && emailValid}
              disabled={profileData?.emailVerified && !emailValid}
              value={formState?.email}
              onChange={handleChange}
              inputAndMessageContainer={StyledMentorEmailInputAndMessageContainer}
              required
            />
          </div>
          {!profileData?.emailVerified && emailValid && (
            <InvalidMessage
              profileData={profileData}
              formState={formState}
              clicked={clicked}
              getProfileData={getProfileData}
              setClicked={setClicked}
              emailValid={emailValid}
              setShowEmailNotVerified={setShowEmailNotVerified}
            />
          )}
          <div className="d-flex justify-content-stretch align-items-center">
            <CustomInput
              label="Whatsapp Number"
              inputAndMessageContainer={StyledPhoneInputContainer}
              component={StyledMentorPhoneNumberInput}
              value={formState?.waId}
              country="in"
              showDropDown={false}
              onChange={handleChangePhone}
              // invalid={!profileData?.mobileVerified}
            />
          </div>
          <CustomSelect
            id="countries"
            label="Location"
            options={unSecureSetupData?.metaCountries?.sort((a, b) => a.name.localeCompare(b.name))}
            getOptionValue={(option) => option?.id}
            getOptionLabel={(option) => option?.name}
            placeholder="Enter your country...."
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999, fontFamily: 'Outfit' }) }}
            disabled={emailValid}
            value={formState?.location?.countryCode}
            selectType={selectTypes?.string}
            onChange={changeCountry}
            required
          /> */}
          <CustomCheckBox
            id="terms"
            label={
              <span>
                By checking this box, I agree to AUMHUM&apos;s{' '}
                <StyledMentorJoinVerifyLink
                  underline="always"
                  href={APP_CONSTANTS.APP_TERMS_URL}
                  target="_blank"
                >
                  Terms of Service
                </StyledMentorJoinVerifyLink>{' '}
                and{' '}
                <StyledMentorJoinVerifyLink
                  underline="always"
                  href={APP_CONSTANTS.APP_PRIVACY_POLICY_URL}
                  target="_blank"
                >
                  Privacy Policy
                </StyledMentorJoinVerifyLink>
                .
              </span>
            }
            checked={formState?.terms}
            onChange={handleChange}
            required
            sx={{
              '&.Mui-checked': {
                color: '#6977df',
              },
            }}
          />
        </MentorOnboardingFormComponent>
      </MentorJoinModalContent>
      <StyledDialogActions>
        {/* {clicked && !profileData?.emailVerified && (
          <StyledDialogSingleAction>
            <StyledDialogVerifiedButton
              disabled={!formState?.terms || verifyingEmail}
              onClick={verifyEmail}
            >
              I have verified my email.
            </StyledDialogVerifiedButton>
            {showEmailNotVerified &&
              (verifyingEmail ? (
                <StyledEmailNotVerifiedMessage verifyEmail={verifyingEmail}>
                  Verifying...
                </StyledEmailNotVerifiedMessage>
              ) : (
                <StyledEmailNotVerifiedMessage>
                  You need to verify your email before proceeding!
                </StyledEmailNotVerifiedMessage>
              ))}
          </StyledDialogSingleAction>
        )} */}
        {/* {!clicked && ( */}
        <StyledDialogJoinButton
          form="join-mentor-form"
          disabled={!disableJoinClinicButton}
          type="submit"
        >
          Get AUMHUM for Clinic
        </StyledDialogJoinButton>
        {/* )} */}
      </StyledDialogActions>
    </Dialog>
  )
}

function InvalidMessage({
  profileData,
  formState,
  emailValid,
  getProfileData,
  clicked,
  setClicked,
  setShowEmailNotVerified,
}) {
  const [sending, setSending] = useState(false)
  const [savingText, setSavingText] = useState('Sending...')
  async function handleClickVerify() {
    setShowEmailNotVerified(false)
    setSending(true)
    if (emailValid) {
      if (!profileData?.email) {
        setSavingText('Updating email...')
        const response = await postMPDataWithoutParams('/api/secure/user/update?languageCode', {
          ...profileData,
          email: formState?.email,
        })
        if (response.status === 200) {
          await getProfileData()
          setSavingText('Sending email...')
        }
      }
      // profileData?.email
      // fire validation api email
      const response = await getMPDataWithoutParams(
        `/api/user/${profileData?.userId}/email/verify/resend`,
      )
      if (response.status) {
        setClicked(true)
      }
    }
    setSending(false)
  }
  return (
    <>
      {sending ? (
        <div>{savingText}</div>
      ) : (
        <>
          {clicked ? (
            <StyledMentorJoinVerifyLinkAfter>
              Verification email sent, please check your inbox. To resend,{' '}
              <StyledMentorJoinVerifyLink onClick={handleClickVerify}>
                click here
              </StyledMentorJoinVerifyLink>
            </StyledMentorJoinVerifyLinkAfter>
          ) : (
            <StyledMentorJoinVerifyLink onClick={clicked ? () => {} : handleClickVerify}>
              Click here to verify your email and continue.
            </StyledMentorJoinVerifyLink>
          )}
        </>
      )}
    </>
  )
}
